var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "page-container" },
        [
          _c(
            "el-form",
            { staticClass: "fr-s-s warp", attrs: { inline: true } },
            [
              _c(
                "el-form-item",
                [
                  _c("el-input", {
                    attrs: { type: "text", placeholder: "请输入门店名称" },
                    model: {
                      value: _vm.query.storeName,
                      callback: function ($$v) {
                        _vm.$set(_vm.query, "storeName", $$v)
                      },
                      expression: "query.storeName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c("el-input", {
                    attrs: { type: "text", placeholder: "请输入用户名称" },
                    model: {
                      value: _vm.query.userName,
                      callback: function ($$v) {
                        _vm.$set(_vm.query, "userName", $$v)
                      },
                      expression: "query.userName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c("el-input", {
                    attrs: { type: "text", placeholder: "请输入护理师名称" },
                    model: {
                      value: _vm.query.nurseName,
                      callback: function ($$v) {
                        _vm.$set(_vm.query, "nurseName", $$v)
                      },
                      expression: "query.nurseName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c("el-input", {
                    attrs: { type: "text", placeholder: "请输入专家名称" },
                    model: {
                      value: _vm.query.expertName,
                      callback: function ($$v) {
                        _vm.$set(_vm.query, "expertName", $$v)
                      },
                      expression: "query.expertName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c("el-input", {
                    attrs: { type: "text", placeholder: "请输入症状名称" },
                    model: {
                      value: _vm.query.symptomName,
                      callback: function ($$v) {
                        _vm.$set(_vm.query, "symptomName", $$v)
                      },
                      expression: "query.symptomName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        size: "small",
                        placeholder: "请选择状态",
                        clearable: "",
                      },
                      model: {
                        value: _vm.query.seekBeautyState,
                        callback: function ($$v) {
                          _vm.$set(_vm.query, "seekBeautyState", $$v)
                        },
                        expression: "query.seekBeautyState",
                      },
                    },
                    _vm._l(_vm.seekBeautyStateList, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-select",
                    {
                      attrs: { size: "small", placeholder: "专家回复状态" },
                      model: {
                        value: _vm.query.expertReplyStatus,
                        callback: function ($$v) {
                          _vm.$set(_vm.query, "expertReplyStatus", $$v)
                        },
                        expression: "query.expertReplyStatus",
                      },
                    },
                    _vm._l(_vm.expertReplyStatusList, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        size: "small",
                        placeholder: "是否为案例",
                        clearable: "",
                      },
                      model: {
                        value: _vm.query.isCase,
                        callback: function ($$v) {
                          _vm.$set(_vm.query, "isCase", $$v)
                        },
                        expression: "query.isCase",
                      },
                    },
                    _vm._l(_vm.isCaseList, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        size: "small",
                        placeholder: "是否转诊",
                        clearable: "",
                      },
                      model: {
                        value: _vm.query.isReferral,
                        callback: function ($$v) {
                          _vm.$set(_vm.query, "isReferral", $$v)
                        },
                        expression: "query.isReferral",
                      },
                    },
                    _vm._l(_vm.isReferralList, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        size: "small",
                        placeholder: "请选择接待状态",
                        clearable: "",
                      },
                      model: {
                        value: _vm.query.receptionState,
                        callback: function ($$v) {
                          _vm.$set(_vm.query, "receptionState", $$v)
                        },
                        expression: "query.receptionState",
                      },
                    },
                    _vm._l(_vm.receptionStateList, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", plain: "" },
                      on: { click: _vm.refreshData },
                    },
                    [_vm._v("搜索")]
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _vm.permission.saveSeekBeautyLog
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary", plain: "" },
                          on: { click: _vm.onAdd },
                        },
                        [_vm._v("添加")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.showLoading,
                  expression: "showLoading",
                },
              ],
              ref: "table",
              attrs: {
                data: _vm.tableData,
                border: "",
                stripe: "",
                "row-key": "seekBeautyId",
                height: _vm.tableHeight,
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "seekBeautyId",
                  label: "编号",
                  align: "center",
                  width: "60",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(" " + _vm._s(scope.$index + 1))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "storeName",
                  label: "门店名称",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "userName", label: "姓名称呼", align: "center" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "userTel",
                  label: "手机号",
                  align: "center",
                  width: "100px",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "receptionName",
                  label: "接待人员名称",
                  align: "center",
                  width: "100px",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(" " + _vm._s(scope.row.receptionName || "--")),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "firstSymptomName",
                  label: "症状名称",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              scope.row.firstSymptomName +
                                " - " +
                                scope.row.secondSymptomName
                            )
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "nurseName",
                  label: "护理师名称",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "expertName",
                  label: "专家名称",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "expertTel",
                  label: "专家电话",
                  align: "center",
                  width: "100px",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "isReferral",
                  label: "是否转诊",
                  width: "90",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("i", {
                          class: [
                            scope.row.isReferral == 1
                              ? "el-icon-check"
                              : "el-icon-close",
                          ],
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "referralTime",
                  label: "转诊时间",
                  width: "140",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          _vm._s(_vm._f("formatDate")(scope.row.referralTime))
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "转诊记录", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.isReferral
                          ? _c(
                              "span",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.showReferralHandle(scope.row)
                                  },
                                },
                              },
                              [
                                _c("el-link", { attrs: { type: "primary" } }, [
                                  _vm._v("查看"),
                                ]),
                              ],
                              1
                            )
                          : _c("span", [_vm._v("--")]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "seekBeautyState",
                  label: "状态",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          _vm._s(
                            _vm._f("getStateName")(
                              scope.row.seekBeautyState,
                              _vm.seekBeautyStateList
                            )
                          )
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "consultTime",
                  label: "咨询时间",
                  align: "center",
                  width: "90px",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "endTime",
                  label: "结束时间",
                  width: "140",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(_vm._s(_vm._f("formatDate")(scope.row.endTime))),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "isCase",
                  label: "是否为案例",
                  width: "90",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("i", {
                          class: [
                            scope.row.isCase == 1
                              ? "el-icon-check"
                              : "el-icon-close",
                          ],
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "receptionState",
                  label: "接待状态",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.receptionState == 0
                          ? _c("span", [_vm._v("已结束")])
                          : scope.row.receptionState == 1
                          ? _c("span", [_vm._v("未接待")])
                          : scope.row.receptionState == 2
                          ? _c("span", [_vm._v("接待中")])
                          : _c("span", [_vm._v("--")]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "seekHelpState",
                  label: "是否求助",
                  width: "90",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("i", {
                          class: [
                            scope.row.seekHelpState == 1
                              ? "el-icon-check"
                              : "el-icon-close",
                          ],
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "addTime",
                  label: "添加时间",
                  width: "140",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(_vm._s(_vm._f("formatDate")(scope.row.addTime))),
                      ]
                    },
                  },
                ]),
              }),
              _vm.permission.setCaseLog ||
              _vm.permission.updateSeekBeautyLog ||
              _vm.permission.removeSeekBeautyLog ||
              _vm.permission.selectStore ||
              _vm.permission.seekBeautyLogInfo
                ? _c("el-table-column", {
                    attrs: {
                      label: "操作",
                      width: "140px",
                      align: "center",
                      fixed: "right",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm.permission.setCaseLog && scope.row.userId > 0
                                ? _c(
                                    "el-tooltip",
                                    {
                                      staticClass: "item",
                                      attrs: {
                                        effect: "dark",
                                        content:
                                          scope.row.isCase === 1
                                            ? "取消案例"
                                            : "设置案例",
                                        placement: "top",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-popconfirm",
                                        {
                                          attrs: {
                                            title:
                                              "您确定要修改日志是否为案例状态吗？",
                                            "icon-color": "red",
                                          },
                                          on: {
                                            confirm: function ($event) {
                                              return _vm.setCaseHandle(
                                                scope.row
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("el-button", {
                                            staticClass: "danger",
                                            attrs: {
                                              slot: "reference",
                                              icon:
                                                scope.row.isCase === 1
                                                  ? "el-icon-close"
                                                  : "el-icon-check",
                                              type: "text",
                                            },
                                            slot: "reference",
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.permission.updateSeekBeautyLog &&
                              scope.row.userId == 0
                                ? _c(
                                    "el-tooltip",
                                    {
                                      staticClass: "item",
                                      attrs: {
                                        effect: "dark",
                                        content: "编辑",
                                        placement: "top",
                                      },
                                    },
                                    [
                                      _c("el-button", {
                                        staticClass: "success",
                                        attrs: {
                                          type: "text",
                                          icon: "el-icon-edit-outline",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.clickEditInfo(scope.row)
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.permission.removeSeekBeautyLog
                                ? _c(
                                    "el-tooltip",
                                    {
                                      staticClass: "item",
                                      attrs: {
                                        effect: "dark",
                                        content: "删除",
                                        placement: "top",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-popconfirm",
                                        {
                                          attrs: {
                                            title: "您确定要删除么？",
                                            "icon-color": "red",
                                          },
                                          on: {
                                            confirm: function ($event) {
                                              return _vm.deleteAdmin(
                                                scope.row,
                                                scope.$index
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("el-button", {
                                            staticClass: "danger",
                                            attrs: {
                                              slot: "reference",
                                              icon: "el-icon-delete",
                                              type: "text",
                                            },
                                            slot: "reference",
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.permission.selectStore
                                ? _c(
                                    "el-tooltip",
                                    {
                                      staticClass: "item",
                                      attrs: {
                                        effect: "dark",
                                        content: "选择",
                                        placement: "top",
                                      },
                                    },
                                    [
                                      _c("el-button", {
                                        staticClass: "success",
                                        attrs: {
                                          icon: "el-icon-circle-check",
                                          type: "text",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.selectStoreHandle(
                                              scope.row
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.permission.seekBeautyLogInfo
                                ? _c(
                                    "el-tooltip",
                                    {
                                      staticClass: "item",
                                      attrs: {
                                        effect: "dark",
                                        content: "求美日志详情",
                                        placement: "top",
                                      },
                                    },
                                    [
                                      _c("el-button", {
                                        staticClass: "success",
                                        attrs: {
                                          type: "text",
                                          icon: "el-icon-tickets",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.clickDetailInfo(
                                              scope.row
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              scope.row.isCase === 1 &&
                              _vm.permission.getQuestionnaireAnswer &&
                              _vm.permission.submitQuestionnaire
                                ? _c(
                                    "el-tooltip",
                                    {
                                      staticClass: "item",
                                      attrs: {
                                        effect: "dark",
                                        content: "设置2.0V案例",
                                        placement: "top",
                                      },
                                    },
                                    [
                                      _c("el-button", {
                                        staticClass: "success",
                                        attrs: {
                                          type: "text",
                                          icon: "el-icon-circle-plus-outline",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.clickSetCaseContent(
                                              scope.row
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2722786952
                    ),
                  })
                : _vm._e(),
            ],
            1
          ),
          _c("el-pagination", {
            ref: "pagination",
            attrs: {
              "current-page": _vm.query.offset,
              "page-sizes": [10, 30, 50, 100],
              "page-size": _vm.query.limit,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.pageTotal,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _c("show-content", {
        attrs: { title: _vm.rowInfo.title, content: _vm.rowInfo.content },
        model: {
          value: _vm.dialogSeeContent,
          callback: function ($$v) {
            _vm.dialogSeeContent = $$v
          },
          expression: "dialogSeeContent",
        },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: `${_vm.editForm.seekBeautyId ? "编辑" : "添加"}`,
            visible: _vm.addOrEditDialog,
            modal: false,
            "destroy-on-close": true,
            fullscreen: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.addOrEditDialog = $event
            },
            close: _vm.resetAddOrEditData,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "editForm",
              attrs: {
                "label-width": "120px",
                model: _vm.editForm,
                rules: _vm.addRules,
              },
            },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "is-required",
                  attrs: { label: "咨询时间", prop: "consultTime" },
                },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "date",
                      placeholder: "请选择咨询时间",
                      "value-format": "yyyy-MM-dd",
                      "picker-options": _vm.pickerOptions0,
                    },
                    model: {
                      value: _vm.editForm.consultTime,
                      callback: function ($$v) {
                        _vm.$set(_vm.editForm, "consultTime", $$v)
                      },
                      expression: "editForm.consultTime",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "姓名称呼", prop: "userName" } },
                [
                  _c("el-input", {
                    attrs: { size: "medium", placeholder: "请输入姓名称呼" },
                    model: {
                      value: _vm.editForm.userName,
                      callback: function ($$v) {
                        _vm.$set(_vm.editForm, "userName", $$v)
                      },
                      expression: "editForm.userName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "手机号", prop: "userTel" } },
                [
                  _c("el-input", {
                    attrs: { size: "medium", placeholder: "请输入手机号" },
                    model: {
                      value: _vm.editForm.userTel,
                      callback: function ($$v) {
                        _vm.$set(_vm.editForm, "userTel", $$v)
                      },
                      expression: "editForm.userTel",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "性别", prop: "sex" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.editForm.sex,
                        callback: function ($$v) {
                          _vm.$set(_vm.editForm, "sex", $$v)
                        },
                        expression: "editForm.sex",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("男")]),
                      _c("el-radio", { attrs: { label: 2 } }, [_vm._v("女")]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "is-required",
                  attrs: { label: "生日", prop: "birthday" },
                },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "date",
                      placeholder: "请选择生日",
                      "value-format": "yyyy-MM-dd",
                      "picker-options": _vm.pickerOptions0,
                    },
                    model: {
                      value: _vm.editForm.birthday,
                      callback: function ($$v) {
                        _vm.$set(_vm.editForm, "birthday", $$v)
                      },
                      expression: "editForm.birthday",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "症状信息", prop: "secondSymptomId" } },
                [
                  _c("el-cascader", {
                    ref: "selectCity",
                    attrs: {
                      options: _vm.symptomList,
                      value: [
                        this.editForm.firstSymptomId,
                        this.editForm.secondSymptomId,
                      ],
                      props: {
                        value: "symptomId",
                        label: "symptomName",
                        children: "children",
                      },
                      placeholder: "请选择症状信息",
                    },
                    on: { change: _vm.selectRegionHandle },
                  }),
                ],
                1
              ),
              _vm.editForm.symptomCompleteList.length > 0
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "is-required",
                      attrs: { label: "症状扩展信息" },
                    },
                    _vm._l(
                      _vm.editForm.symptomCompleteList,
                      function (item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticStyle: {
                              display: "flex",
                              "-webkit-flex-wrap": "wrap",
                              "-moz-flex-wrap": "wrap",
                              "-ms-flex-wrap": "wrap",
                              "-o-flex-wrap": "wrap",
                              "flex-wrap": "wrap",
                            },
                          },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop:
                                    "symptomCompleteList." +
                                    index +
                                    ".selectCompleteOptionId",
                                  label: item.completeName,
                                  "label-width": "90px",
                                  rules: _vm.addRules.selectCompleteOptionId,
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "200px" },
                                    attrs: {
                                      size: "small",
                                      placeholder: "请选择症状扩展信息选项",
                                    },
                                    model: {
                                      value: item.selectCompleteOptionId,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          item,
                                          "selectCompleteOptionId",
                                          $$v
                                        )
                                      },
                                      expression: "item.selectCompleteOptionId",
                                    },
                                  },
                                  _vm._l(
                                    item.completeOptionInfoList,
                                    function (grade) {
                                      return _c("el-option", {
                                        key: grade.completeOptionId,
                                        attrs: {
                                          label: grade.completeOptionName,
                                          value: grade.completeOptionId,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      }
                    ),
                    0
                  )
                : _vm._e(),
              _vm.editForm.seekBeautyId == 0
                ? _c(
                    "el-form-item",
                    { attrs: { label: "实拍图集", prop: "galleryList" } },
                    [
                      _c("UploadImageNewOne", {
                        attrs: {
                          limit: 9,
                          imgList: _vm.editForm.galleryList,
                          accept: "image/*",
                        },
                        on: {
                          "update:imgList": function ($event) {
                            return _vm.$set(_vm.editForm, "galleryList", $event)
                          },
                          "update:img-list": function ($event) {
                            return _vm.$set(_vm.editForm, "galleryList", $event)
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  staticClass: "is-required",
                  attrs: { label: "备注", prop: "remark" },
                },
                [
                  _c("el-input", {
                    attrs: {
                      size: "medium",
                      type: "textarea",
                      maxlength: "255",
                      "prefix-icon": "el-icon-user",
                      placeholder: "请填写备注",
                    },
                    model: {
                      value: _vm.editForm.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.editForm, "remark", $$v)
                      },
                      expression: "editForm.remark",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.clickAddOrEditCancel } }, [
                _vm._v("取 消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.addOrEditBtnLoading },
                  on: { click: _vm.clickAddOrEditConfirm },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "absolute",
          attrs: {
            title: `实拍图集`,
            visible: _vm.dialogSeekBeautyLogGalleryVisible,
            modal: false,
            "destroy-on-close": true,
            fullscreen: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogSeekBeautyLogGalleryVisible = $event
            },
          },
        },
        [
          _vm.dialogSeekBeautyLogGalleryVisible
            ? _c("SeekBeautyLogGalleryList", {
                attrs: { seekBeautyId: _vm.selectSeekBeautyId },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "absolute",
          attrs: {
            title: `求美日志消息`,
            visible: _vm.dialogSeekBeautyLogMessageVisible,
            modal: false,
            "destroy-on-close": true,
            fullscreen: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogSeekBeautyLogMessageVisible = $event
            },
          },
        },
        [
          _vm.dialogSeekBeautyLogMessageVisible
            ? _c("SeekBeautyLogMessageList", {
                attrs: {
                  seekBeautyId: _vm.selectSeekBeautyId,
                  userId: _vm.selectUserId,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "absolute",
          attrs: {
            title: `转诊记录`,
            visible: _vm.dialogReferralRecordVisible,
            modal: false,
            "destroy-on-close": true,
            fullscreen: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogReferralRecordVisible = $event
            },
          },
        },
        [
          _vm.dialogReferralRecordVisible
            ? _c("ReferralRecordList", {
                attrs: { seekBeautyId: _vm.selectSeekBeautyId },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "absolute",
          attrs: {
            title: `求美日志详情`,
            visible: _vm.dialogSeekBeautyLogDetailVisible,
            modal: false,
            "destroy-on-close": true,
            fullscreen: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogSeekBeautyLogDetailVisible = $event
            },
          },
        },
        [
          _vm.dialogSeekBeautyLogDetailVisible
            ? _c("SeekBeautyLogDetail", {
                attrs: { seekBeautyId: _vm.selectSeekBeautyId },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "absolute",
          attrs: {
            title: `设置2.0V案例`,
            visible: _vm.dialogSetCaseContentVisible,
            modal: false,
            "destroy-on-close": true,
            fullscreen: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogSetCaseContentVisible = $event
            },
          },
        },
        [
          _vm.dialogSetCaseContentVisible
            ? _c("SetCaseContent", {
                attrs: {
                  seekBeautyId: _vm.selectSeekBeautyId,
                  consultationTypeId: _vm.selectConsultationTypeId,
                },
                on: { hideShow: _vm.hideShowMethod },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }